export default {
    accept_document: "Accept",
    agreement_status_not_signed: "Not signed",
    agreement_status_signed: "Signed",
    all_other_countries: "All other countries",
    effective_at: "Effective date",
    legal_agreement: "Agreement",
    legal_document: "Legal document",
    legal_document_countries_note: "If no country is selected, the document applies to every country that doesn't have its own document of this type.",
    legal_document_is_active_note: "Only one version of a document type and region can be active at a time. Activating this version automatically deactivates the previous active one.",
    legal_document_must_accept_note: "To continue, please review and accept the document.",
    legal_document_superadmin_authority_note: "By accepting this document, you confirm that you are authorized to act on behalf of the organization.",
    legal_document_type: "Document type",
    legal_document_type_offer_contract: "Offer contract",
    legal_document_type_integrations_agreement: "Third-party services and integrations agreement",
    legal_document_type_usage_agreement: "Software usage agreement",
    legal_document_usage_agreement_note: "By accepting this document, you confirm that you have read the software usage rules and agree to comply with them.",
    legal_documents: "Legal documents",
    loading: "Loading",
    no_legal_documents_for_region: "No documents have been published for your region yet",
    open_document: "Open document",
    requires_reacceptance: "Requires re-acceptance",
    requires_reacceptance_note: "If enabled, users who accepted a previous version will have to accept this version again on their next login.",
    version: "Version"
}
